import { useTranslation } from "react-i18next";
import type { YearlyTotal } from "../../lib/dividends-utils";
import { YearTile } from "./YearTile";

interface Props {
  years: YearlyTotal[]; // erwartet: bereits absteigend sortiert (Neueste zuerst)
  selectedYear: number;
  onSelectYear: (year: number) => void;
  onLoadOlder?: () => void; // nur wenn es was zu laden gibt
}

export function YearSidebar({ years, selectedYear, onSelectYear, onLoadOlder }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      {years.map((y) => (
        <YearTile
          key={y.year}
          data={y}
          active={y.year === selectedYear}
          onClick={() => onSelectYear(y.year)}
        />
      ))}
      {onLoadOlder && (
        <button
          type="button"
          onClick={onLoadOlder}
          className="w-full text-xs py-2 rounded-lg border font-medium"
          style={{ color: "var(--muted)", borderColor: "var(--border)", background: "var(--card)" }}
        >
          {t("dividends.loadOlder")}
        </button>
      )}
    </div>
  );
}
